const React = require('react');
const map = require('mn-utils/map');
const formatTime = require('mn-utils/formatTime');
const upperFirst = require("mn-utils/upperFirst");

const paymentTypes = require("../../../../../constants/paymentTypes");

const DataBlock = require('./DataBlock');
const Tooltip = require("../../../../dumb/Tooltip/B");
const {DisplayIdMerchant, DisplayAddressMerchant, DisplayDateDetailedMerchant, DisplayAmountMerchant} = require("../../../../dumb/DisplayData");

module.exports = (props) => {
  const data = props.data || {};
  const dataArr = [
    {
      title: 'Trx ID',
      value: (
        <DisplayIdMerchant className="fhaS">
          {data.id}
        </DisplayIdMerchant>
      ),
    },
    {
      title: 'Customer ID',
      value: (
        <DisplayIdMerchant className="fhaS">
          {data.account_id}
        </DisplayIdMerchant>
      ),
    },
    {
      title: 'Payment Method',
      value: paymentTypes[data.payment_method] || (data.payment_method || '').split('_').map((el) => upperFirst(el)),
    },
    {
      title: 'Transaction created',
      value: (
        <DisplayDateDetailedMerchant
          className="fhaS"
          date={data.created_at}
        />
      ),
    },
    {
      title: 'Amount (Fiat)',
      value: (
        <DisplayAmountMerchant
          className="fhaS"
          amount={data.fiat_amount}
          symbol={data.fiat_code}
          type="fiat"
        />
      ),
    },
    {
      title: 'Amount (Crypto)',
      value: (
        <DisplayAmountMerchant
          className="fhaS"
          amount={data.crypto_amount}
          symbol={data.cc_code}
          type="fiat"
        />
      ),
    },
    {
      title: 'Commissions Earned',
      value: (
        <DisplayAmountMerchant
          className="fhaS"
          amount={data.comissions_earned}
          symbol={data.comissions_asset}
          type="fiat"
        />
      ),
    },
    {
      title: 'Receiver address',
      value: (
        <DisplayAddressMerchant className="fhaS">
          {data.wallet_address}
        </DisplayAddressMerchant>
      ),
    },
  ];

  return (
    <div className="layoutRow fxwWrap m-15 mb34">
      {map(dataArr, (item, i) => (
        <div key={i} className="w1/4 w1/2@m w@m2 mt21 ph15">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
